import { Component, Injectable } from '@angular/core';
import { Http, Response } from '@angular/http'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ITestListRequest} from '../_models/ITestListRequest'

@Injectable()
export class ManageServices {

    constructor(private http: Http) { }

    getExamDetails(testobj:ITestListRequest): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = {TestListRequestObj:testobj};
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/GetAllExamDetailsForUser",content).map(
            (response: Response) => response.json());
    }

    getAssessmentDetails(examCode,pageNo,pageSize): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = { examCode: examCode,pageNo:pageNo,pSize:pageSize};
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/GetExamAssessmentDetailsForExamCode", content).map(
            (response: Response) => response.json()
        );
    }

    TakeTest(SUID): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = { ScheduleUserID: SUID };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/TakeTest", content).map(
            (response: Response) => response.json()
        );
    }

    ViewBadges(rowIndexData): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = { rowIndex: rowIndexData };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Home.aspx/GetViewBadge", content).map(
            (response) => response.json()
        );
    }

    FindProctor(): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = {};
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Home.aspx/ReturnParam", content).map(
            (response) => response.json()
        );
    }

    getRetake(): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = {};
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/HandleRetakeTest", content).map(
            (response) => response.json()
        );
    }

    getReport(CurrentSUID): Observable<any> {
        var TestDetails: any = {
        };
        TestDetails.TestSelected = -1;
        TestDetails.Option = 9;
        TestDetails.RVType = 111;
        TestDetails.RowIndex = -1;
        TestDetails.CustomOption = 0;

        TestDetails.ID = CurrentSUID;
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        var content = { objTestDetails: TestDetails };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/RedirectToReportSSO", content).map(
            (response) => response.json()
        );
    }

    ViewCertificationBasedonLevels(certificationlevel, ID): Observable<any> {
        var TestDetails: any = {};
        TestDetails.RowIndex = certificationlevel;
        TestDetails.Option = 11;
        TestDetails.RVType = 531;
        TestDetails.CustomOption = 1;
        TestDetails.ID = ID;
        var content = { objTestDetails: TestDetails };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Home.aspx/RedirectToReportSSO", content).map(
            (response) => response.json()
        );
    }

    ViewSolution(RIndex, testID): Observable<any> {
        var TestDetails: any = {};
        TestDetails.RowIndex = RIndex;
        TestDetails.ID = testID;
        var content = { objTestDetails: TestDetails };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/ExamPackage.aspx/GetSolutionDetailsByRowIndex", content).map(
            (response) => response.json()
        );
    }

    private handleError(error: Response | any) {
        console.error('ApiService::handleError', error);
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/exampackage/exampackage.service.ts